import { GenderEnum } from '../contracts';

export const genderList = [
  { value: GenderEnum.MALE, label: 'Masculino' },
  { value: GenderEnum.FEMALE, label: 'Feminino' },
  { value: GenderEnum.NOT_INFORMED, label: 'Prefiro não responder' },
];
